import React, { useEffect, useState } from 'react';
import { CTAButton } from './CTAButton';
import { Star, Shield } from 'lucide-react';
const CHECKOUT_URL = 'https://functional-trainer-system.impultienda.ar/checkout';
export function PricingCard() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 1,
    minutes: 3,
    seconds: 33
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) {
          seconds--;
        } else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        } else {
          hours = 1;
          minutes = 3;
          seconds = 33;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section id="pricing" className="py-10 px-4 bg-white border-y border-brand-gold/30 scroll-mt-4" data-id="element-117">
      <div className="max-w-2xl mx-auto" data-id="element-118">
        <div className="text-center mb-5" data-id="element-119">
          <p className="text-sm font-bold text-brand-gold uppercase tracking-wide mb-2" data-id="element-120">
            Sonderangebot — Vollständiges 6-in-1-System
          </p>
          <p className="text-base text-brand-graphite/80 mb-3" data-id="element-121">
            Erhalten Sie sofortigen Zugang und verwandeln Sie die Art, wie Sie
            Ihre Trainingseinheiten planen und durchführen.
          </p>
          <div className="inline-block bg-brand-petrol/10 border-2 border-brand-petrol px-4 py-1.5 rounded-lg" data-id="element-122">
            <p className="font-bold text-brand-petrol text-lg" data-id="element-123">
              🏋️ FUNCTIONAL TRAINER SYSTEM™
            </p>
          </div>
        </div>

        <div className="bg-brand-cream border-4 border-brand-gold rounded-xl p-5 sm:p-6 text-center relative mb-5" data-id="element-124">
          <div className="mb-5" data-id="element-125">
            <p className="text-base text-brand-graphite/70 mb-1" data-id="element-126">
              Regulärer Preis: <span className="line-through" data-id="element-127">97 €</span>
            </p>
            <p className="text-lg font-bold text-red-600 mb-3" data-id="element-128">
              🔥 72% RABATT — BEGRENZTES EINFÜHRUNGSANGEBOT
            </p>
            <p className="text-sm text-brand-graphite/70 mb-2" data-id="element-129">Nur heute:</p>
            <p className="text-5xl font-serif font-bold text-brand-petrol mb-2" data-id="element-130">
              37 € EUR
            </p>
            <p className="text-sm text-brand-graphite/70" data-id="element-131">
              Bezahlen Sie sicher in Ihrer lokalen Währung.
            </p>
          </div>

          <div className="bg-red-50 border-2 border-red-300 rounded-lg p-4 mb-6" data-id="element-132">
            <p className="text-sm font-bold text-red-600 mb-3" data-id="element-133">
              🔥 Letzte Chance! Dieser Sonderpreis läuft ab, wenn der Countdown
              auf null geht.
            </p>
            <div className="flex justify-center gap-4" data-id="element-134">
              {[{
              v: timeLeft.hours,
              l: 'STUNDEN'
            }, {
              v: timeLeft.minutes,
              l: 'MINUTEN'
            }, {
              v: timeLeft.seconds,
              l: 'SEKUNDEN'
            }].map((t, i) => <div key={i} className="text-center" data-id="element-135">
                  <div className="bg-brand-petrol text-white text-2xl font-bold px-4 py-2 rounded" data-id="element-136">
                    {String(t.v).padStart(2, '0')}
                  </div>
                  <p className="text-xs text-brand-graphite/70 mt-1" data-id="element-137">{t.l}</p>
                </div>)}
            </div>
          </div>

          <CTAButton href={CHECKOUT_URL} data-id="element-138">
            🚀 JA! ICH MÖCHTE MEIN 6-IN-1-SYSTEM (37 €)
          </CTAButton>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-2 text-sm text-brand-graphite/70" data-id="element-139">
          <div className="flex items-center gap-1" data-id="element-140">
            <Star className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-141" />
            <span className="font-semibold" data-id="element-142">
              4,9/5 – Verifizierte Bewertungen
            </span>
          </div>
          <span className="hidden sm:inline" data-id="element-143">•</span>
          <div className="flex items-center gap-1" data-id="element-144">
            <Shield className="w-4 h-4 text-brand-petrol" data-id="element-145" />
            <span className="font-semibold" data-id="element-146">7-Tage-Garantie – Null Risiko</span>
          </div>
        </div>
      </div>
    </section>;
}